import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table, Spin, Row, Col, Form, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
// import Table from '../components/Table';
import { getPermissions } from 'redux/auth/actions';
import RolesActions from 'redux/roles/actions';
import crudSelectors from 'redux/crudSelectors';
import Box from 'components/common/Box';
import { getValidData, getSearch, getFilterFromUrl } from 'utils/tools';
import i18next from 'i18next';
import PageTitle from 'components/common/PageTitle';
import { push } from 'connected-react-router';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';
import PermissionsListStyles from 'containers/Permissions/List/styles';
import SelectionPermissionModal from '../components/SelectionPermissionModal';

const Roles = ({ location }) => {
  const dispatch = useDispatch();
  const permissionConfigs = useSelector((state) => state.auth.permissions);
  const roles = useSelector(crudSelectors.roles.getDataArr);
  const loading = useSelector(crudSelectors.roles.getLoading);
  const filter = useSelector(crudSelectors.roles.getFilters);
  const [selected, setSelected] = useState(null);
  const [filterPermissionName, setFilterPermissionName] = useState('');
  const debounceSetFilterPermissionName = debounce(
    setFilterPermissionName,
    300,
  );

  const onSelectPermission = (record, data, i, config) => {
    setSelected({ record, data, index: i, config });
  };

  const onSearchPermissionName = (text) => {
    debounceSetFilterPermissionName(text);
  };

  const columns = permissionConfigs
    ? [
        {
          key: 'name',
          fixed: 'left',
          width: 200,
          title: i18next.t('roles.name'),
          dataIndex: `name`,
          render: (data, record) => (
            <div style={{ width: 200 }}>
              <Link to={`#roles/${record.id}/edit`}>{data}</Link>
            </div>
          ),
        },
        ...permissionConfigs
          .filter(
            (e) =>
              e.title
                .toLocaleLowerCase()
                .indexOf(filterPermissionName.toLocaleLowerCase()) > -1,
          )
          .map((config, i) => ({
            ...config,
            dataIndex: `permission.${config.key}`,
            key: config?.title + i,
            checkbox: true,
            align: 'center',
            render: (data, record) => (
              <Button
                onClick={() => onSelectPermission(record, data, i, config)}
              >
                {`${data?.length || 0}/${config?.permissions?.length}`}
              </Button>
            ),
            // children: config?.permissions?.map((e, index) => ({
            //   title: stringtoWord[e],
            //   align: 'center',
            //   key: `${i}-${config?.title}.${e}-${index}`,
            //   dataIndex: `permissions`,
            //   render: (data, record) => (
            //     <PermissionCheckbox
            //       index={i}
            //       roleIndex={
            //         data && findIndex(data, (e) => e.title === config?.title)
            //       }
            //       config={config}
            //       rootPermission={config.key}
            //       key={e}
            //       permissionKey={e}
            //       data={data}
            //       record={record}
            //     />
            //   ),
            // })),
          })),
      ]
    : [];

  const onChangePagination = (e, filters, sorter) => {
    const formatSort =
      sorter && sorter.field && sorter.order
        ? `${sorter.order === 'descend' ? '-' : ''}${sorter.field}`
        : null;
    dispatch(
      RolesActions.getAllRoles(
        {
          page: e.current,
          limit: e.pageSize,
          filter: {
            ...getValidData({ ...filter.filter, isDelete: false }, true),
          },
          orderBy: formatSort,
        },
        { isRefresh: true },
      ),
    );

    dispatch(
      push(
        `/roles?${getSearch({
          page: e.current,
          limit: e.pageSize,
          filter: {
            ...getValidData({ ...filter.filter }, true),
          },
          orderBy: formatSort,
        })}`,
      ),
    );
  };

  const onSearch = (e) => {
    dispatch(
      RolesActions.getAllRoles(
        {
          ...filter,
          filter: {
            ...filter?.filter,
            isDelete: false,
          },
          offset: 0,
          q: e,
        },
        { isRefresh: true },
      ),
    );

    dispatch(
      push(
        `/roles?${getSearch({
          ...filter,
          q: e,
        })}`,
      ),
    );
  };

  useEffect(() => {
    dispatch(getPermissions());
    dispatch(
      RolesActions.getAllRoles(
        getFilterFromUrl(location.search) || {
          limit: 5,
          orderBy: 'displayName',
          filter: {
            isDelete: false,
          },
        },
        { isRefresh: true },
      ),
    );
    // eslint-disable-next-line
  }, []);
  return (
    <PermissionsListStyles>
      <PageTitle>{i18next.t('roles.header')}</PageTitle>
      <Box>
        <Row gutter={20}>
          <Col md={12} sm={24}>
            <Form.Item label={i18next.t('permissions.searchName')}>
              <div>
                <Input.Search
                  defaultValue={
                    filter?.q || getFilterFromUrl(location.search)?.q
                  }
                  onSearch={onSearch}
                />
              </div>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item label={i18next.t('permissions.filterPermissionName')}>
              <div>
                <Input.Search onSearch={onSearchPermissionName} />
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Box>
      {permissionConfigs ? (
        <Box>
          <Table
            rowKey="id"
            loading={loading}
            scroll={{ x: '1200px' }}
            tableLayout="auto"
            dataSource={roles}
            columns={columns}
            bordered
            onChange={onChangePagination}
            pagination={{
              total: filter.count,
              current: filter.page,
              pageSize: filter.limit,
              showQuickJumper: true,
              showSizeChanger: true,
            }}
          />
        </Box>
      ) : (
        <Spin />
      )}
      <SelectionPermissionModal
        onCancel={() => setSelected(null)}
        {...selected}
      />
    </PermissionsListStyles>
  );
};

Roles.propTypes = {
  location: PropTypes.object,
};

Roles.defaultProps = {
  resource: 'auth/permission',
  rootPath: '',
  redirects: {
    edit: 'modal',
    create: 'modal',
  },
  initCreateData: {},
};

export default Roles;
